import { render, staticRenderFns } from "./dataEventTable.vue?vue&type=template&id=b61a8dfa&scoped=true"
import script from "./dataEventTable.vue?vue&type=script&lang=js"
export * from "./dataEventTable.vue?vue&type=script&lang=js"
import style0 from "./dataEventTable.vue?vue&type=style&index=0&id=b61a8dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a8dfa",
  null
  
)

export default component.exports